define('app-MakePayment/main',['./settings'], function (settings) {
    return {
        run: function () {
            if ($(settings.container).length === 0) {
                window.log("No Portal Container found, make a payment will not be available.");

                return;
            }

            function updateErrorMessage(error, additional) {
                if (error !== "") {
                    error += "<br />";
                }
                error += additional;
                return error;
            }

            $(settings.makePayment).on("click", function () {
                var errorMessage = "",
                    isValid = true,
                    width = Math.ceil($('.innerContent').width());

                $(settings.screenWidth).val(width);
                $(settings.screenHeight).val(800);

                var $paymentType = $("input[name='PaymentType']:checked").val(),
                    $customPaymentAmountValue = $(settings.customPaymentAmount).val(),
                    $bookingBalanceDueValue = parseFloat($(settings.bookingBalanceDue).val()).toFixed(2),
                    $minimumAmountPayableValue = $(settings.minimumAmountPayable).val();
                var leadPaxEmailAddressValue = $(settings.leadPaxEmailAddress).val();

                if (leadPaxEmailAddressValue != undefined && leadPaxEmailAddressValue === "") {
                    errorMessage = updateErrorMessage(errorMessage, "Please enter confirmation email send to address");
                }

                if (!$paymentType) {
                    errorMessage = updateErrorMessage(errorMessage, "Please select how much you would like to pay today");
                }

                if ($paymentType === "paycustomvalue" &&
                    ($customPaymentAmountValue === "" || isNaN($customPaymentAmountValue) || parseFloat($customPaymentAmountValue) > parseFloat($bookingBalanceDueValue) ||
                        parseFloat($customPaymentAmountValue) < parseFloat($minimumAmountPayableValue))) {
                    var message = "Amount must be greater than or equal to &#163;" + $minimumAmountPayableValue + ".00 and less than or equal to &#163;" + $bookingBalanceDueValue;
                    errorMessage = updateErrorMessage(errorMessage, message);
                }

                $(".notification").html(errorMessage);

                if (errorMessage != "") {
                    isValid = false;
                    $(".notification").removeClass("d-none");
                } else {
                    $(".notification").addClass("d-none");
                }

                return isValid;
            });
        }
    }
});
